import { IEnvironment, RecordSource, Store } from "relay-runtime";
import {
	errorMiddleware,
	loggerMiddleware,
	perfMiddleware,
	RelayNetworkLayer,
	retryMiddleware,
	uploadMiddleware,
	urlMiddleware,
} from "react-relay-network-modern";
import { toast } from "react-toastify";
import RelayModernEnvironment from "relay-runtime/lib/store/RelayModernEnvironment";
import { JwtMiddleware } from "./JwtMiddleware";
import { ErrorHandlingMiddleware } from "./ErrorHandlingMiddleware";
import { WSSubscription } from "./WSSubscription";

export const TK_SSO_TOKEN_COOKIE_NAME = "SESStkssocookie";

// Export a singleton instance of Relay Environment configured with our network function:
const relayStore = new Store(new RecordSource());

const isDev = process.env.NODE_ENV === "development";
const network = new RelayNetworkLayer(
	[
		urlMiddleware({
			url: () => Promise.resolve(`${process.env.REACT_APP_API_BASE}/api/graphql`),
		}),
		isDev ? loggerMiddleware() : null,
		isDev ? errorMiddleware() : null,
		isDev ? perfMiddleware() : null,
		retryMiddleware({
			fetchTimeout: 15000,
			retryDelays: (attempt) => Math.pow(2, attempt + 4) * 100, // or simple array [3200, 6400, 12800, 25600, 51200, 102400, 204800, 409600],
			beforeRetry: ({ abort, attempt }) => {
				if (attempt > 3) {
					abort();
					toast.error(
						"Couldn't make connection with API - please wait a few minutes and check your internet connection.",
					);
					window.location.href = "/unerwartet";
				}
			},
			statusCodes: [500, 503, 504],
		}),
		JwtMiddleware,
		uploadMiddleware(),
		ErrorHandlingMiddleware,
	],
	{
		subscribeFn: WSSubscription,
	},
);

export const RelayEnvironment: IEnvironment = new RelayModernEnvironment({
	network: network,
	store: relayStore,
});
